import { IMPORT_DATALAKE_PATH, RECEIVABLE_CONCESSIONS_PATH, RECEIVABLE_CONCESSIONS_FORM_PATH, RECEIVABLE_WALLETS_PATH, RECEIVABLE_WALLETS_FORM_PATH, LOTES_DADOS_EXTERNOS_PATH } from "src/utils/api-routes"
import { formatDecimalCaseReplaceDot, formatToFloatDecimalCase } from "src/utils/format-decimal"
import { ServiceRequest } from "src/utils/service-request"

class ImportFileService {
    constructor() {
        this.serviceRequest = new ServiceRequest()
    }

    getAPPList() {
        return [
            { value: 'cadastro', description: "Cadastro" },
            { value: 'cbonds', description: "CBonds" },
            { value: 'calculo', description: "CreditCalc" },
            { value: 'datalake', description: "DataLake" },
            { value: 'recebiveis', description: "GR" },
            { value: 'motor', description: "Motor" },
            { value: 'rater', description: "Rater" },
        ]
    }

    async sendDataLakeFile(selectedFile, importType, app) {
        const formData = new FormData()

        formData.append('arquivo', selectedFile)
        formData.append('modelo', importType)
        formData.append('app', app)

        return this.serviceRequest.postFormData(IMPORT_DATALAKE_PATH, formData)
    }

    async sendReceivableOperationFile(selectedFile, filename) {
        const formData = new FormData()

        formData.append('arquivo', selectedFile)
        formData.append('filename', filename)

        return this.serviceRequest.postFormData(RECEIVABLE_CONCESSIONS_PATH, formData)
    }

    async sendWalletForm(jsonData) {
        const json_convertido = JSON.stringify(jsonData)
        console.log("🚨 JSON ENVIADO 🚨:", jsonData)
        console.log("🚨 service_request: 🚨", this.serviceRequest.baseUrl)
        return this.serviceRequest.post(RECEIVABLE_WALLETS_FORM_PATH, json_convertido)
    }

    async sendConcessionForm(jsonData, filename) {
        const payload = {
            ...jsonData, // chave operações
            filename: filename
        }
        const json_convertido = JSON.stringify(payload)
        console.log("🚨 JSON ENVIADO 🚨:", json_convertido)
        console.log("🚨 service_request 🚨:", this.serviceRequest.baseUrl)
        return this.serviceRequest.post(RECEIVABLE_CONCESSIONS_FORM_PATH, json_convertido)
    }

    async sendReceivableWalletFile(selectedFile, nomeCarteira, valorPercentil, subordinacao, caixa) {
        const formData = new FormData()
        const valorCaixaFormatado = formatToFloatDecimalCase(formatDecimalCaseReplaceDot(caixa))
        const valorCaixa = (valorCaixaFormatado) !== null ? valorCaixaFormatado : 0
        const formatedSubordinacao = subordinacao.map(({
            nomeCota,
            plCota,
            indexador,
            taxaAccrual,
            durationCota
        }) => {
            let DU = durationCota
            if (DU === '') {
                return {
                    "NomeCota": nomeCota,
                    "PLCota": formatToFloatDecimalCase(plCota),
                    "Indexador": indexador,
                    "TaxaAccrual": parseFloat(taxaAccrual)
                }
            }
            else if (nomeCota === '' || !plCota || indexador === '' || !taxaAccrual){
                return {
                    "error": "Preencha todas as informações de pelo menos uma cota."
                }
            }
            else {// console.log('Este é o valor APÓS O IF de DU: ', DU, ' e o tipo', typeof DU)
                return {
                    "NomeCota": nomeCota,
                    "PLCota": formatToFloatDecimalCase(plCota),
                    "Indexador": indexador,
                    "TaxaAccrual": parseFloat(taxaAccrual),
                    "DurationCota": parseFloat(durationCota)
                }
            }
        })

        const parsedSubordinacao = JSON.stringify(formatedSubordinacao)
        console.log('Este é o valor de parsedSubordinacao:', parsedSubordinacao)

        formData.append('arquivo', selectedFile)
        formData.append('nome_carteira', nomeCarteira)
        formData.append('percentil', valorPercentil)
        formData.append('caixa', valorCaixa)
        formData.append('subordinacao[]', parsedSubordinacao)

        return this.serviceRequest.postFormData(RECEIVABLE_WALLETS_PATH, formData)
    }

    async loadLastImports(limit = 200, type) {
        return this.serviceRequest.get(`${LOTES_DADOS_EXTERNOS_PATH}?limit=${limit}&rotina=${type}`)
    }

    verifyTableStatus(value) {
        let text = "Não informado"
        let color = ""
        switch (value) {
            case "DONE":
                text = "SUCESSO"
                color = "success"
                break
            case "IN_PROGRESS":
                text = "EM PROGRESSO"
                color = "primary"
                break
            case "PENDING":
                text = "PENDENTE"
                color = "warning"
                break
            case "ERROR":
                text = "ERRO"
                color = "error"
                break
            case "FILE_ERROR":
                text = "ERRO NO ARQUIVO"
                color = "error"
                break
        }

        return {
            text: text,
            color: color
        }
    }

}

export default ImportFileService